import React from 'react'
import './contact.css'

import emailjs from "emailjs-com";

const Contact = () => {
  function sendEmail(e) {
        e.preventDefault();
        console.log(e.target);

        emailjs.sendForm('service_n9uz3yr', 'template_3h2k87r', e.target, '1gJ9omYAENzgU5S6N')
        .then((result) => {
          console.log(result.text);
          document.getElementsByClassName('sentSuccessfully')[0].style.display = 'block';
        }, (error) => {
          console.log(error.text);
          document.getElementsByClassName('notSent')[0].style.display = 'block';
        });
        e.target.reset()

    }

  return (
	<section id="contact">
    <h5>Please leave a message</h5>
    <h2>Contact me</h2>
    <div className="container contact__container"> 
      <div className="contact__content">
        <form onSubmit={sendEmail}>
              <input type="text" className="feedback-input" placeholder="Name" name="name"/>
              <input type="email" className="feedback-input" placeholder="Email Address" name="email"/>
              <textarea className="feedback-input" id="" cols="30" rows="8" placeholder="Your message" name="message"></textarea>
              <div className="submit-btn">
                <input type="submit" className="btn btn-primary send-msg" value="Send Message"></input>
              </div>
              <div className="col-10 pt-3 mx-auto sentSuccessfully">
                <p>Message sent successfully!</p>
              </div>
              <div className="col-10 pt-3 mx-auto notSent">
                <p>Message not sent successfully, Please try again later.</p>
              </div>
          </form>

     
      </div>
    </div>
  </section>
  )
}

export default Contact;
